(() => {
 if(window.kareGalleryBound)return;
 window.kareGalleryBound=true;
 function show(thumb){
  const gallery=thumb.closest('[data-kare-gallery]');if(!gallery)return;
  const image=gallery.querySelector('[data-gallery-main]');
  image.src=thumb.href;image.alt=thumb.dataset.alt||'';
  gallery.querySelector('[data-gallery-zoom]').href=thumb.href;
  gallery.querySelector('[data-gallery-caption]').textContent=thumb.dataset.caption||'';
  gallery.querySelectorAll('[data-gallery-thumb]').forEach(item=>item.removeAttribute('aria-current'));
  thumb.setAttribute('aria-current','true');
 }
 document.addEventListener('click',event=>{
  const thumb=event.target.closest('[data-gallery-thumb]');
  if(!thumb||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;
  event.preventDefault();show(thumb);
 });
 document.addEventListener('shopify:block:select',event=>{
  const thumb=event.target.matches('[data-gallery-thumb]')?event.target:event.target.querySelector('[data-gallery-thumb]');
  if(thumb)show(thumb);
 });
})();
